export const messages = {
  get: 'messages-received',
  send: 'message-transmitted',
  remove: 'message-deleted',
  update: 'message-updated',
  updated: 'updated-messages-received'
}
